<template>
  <v-row justify="center" align="center">
    <v-progress-circular
      :size="70"
      :width="7"
      indeterminate
      color="primary"
    ></v-progress-circular>
  </v-row>
</template>
<script>
import mixin from "@/mixin";
export default {
  mixins: [mixin.Cognito],
  created() {
    var currUrl = window.location.href;
    this.auth.parseCognitoWebResponse(currUrl);
  },
};
</script>